import { styled } from "@mui/system";
import GlobalTheme from "./styles/global.theme";
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import Box from "@mui/material/Box";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import {
    Container,
    LinearProgress,
    Menu,
    MenuItem,
    FormControl,
    IconButton,
    Button,
    Snackbar,
    Popover,
    DialogActions,
    CircularProgress,
    Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { TimelineContent, TimelineDot } from "@mui/lab";
import Toolbar from "@mui/material/Toolbar";

export const CustomIconArrowButton = styled(IconButton)({
    position: "absolute",
    left: 0,
    width: "40px",
    height: "40px",
});

export const CustomIconButton = styled(IconButton)({});

export const CustomButton = styled(Button)({});

export const CustomTypography = styled(Typography)({});

export const CustomDialogActions = styled(DialogActions)({});

export const CustomCircularProgress = styled(CircularProgress)({
    color: `${GlobalTheme.palette.white.primary.main}`,
});

export const CustomMenuItem = styled(MenuItem)({});

export const CustomPopover = styled(Popover)({});

export const CustomBox = styled(Box)({});

export const CustomToolbar = styled(Toolbar)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: "12px",
    "@media (max-width: 1024px)": {
        paddingTop: "5px",
    },
});

export const CustomSnackbar = styled(Snackbar)({
    width: "30%",
    border: `2px solid ${GlobalTheme.palette.green.primary.main}`,
    borderRadius: "6px",
});

export const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
    />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: `${GlobalTheme.palette.purple.primary.lighter}`,
        color: `${GlobalTheme.palette.black.primary.main}`,
        boxShadow: theme.shadows[1],
        fontSize: 16,
        padding: "20px",
        maxWidth: "300px",
        lineHeight: "20px",
        fontFamily: "Calibre",
        fontWeight: "400",
    },
}));

export const CustomAlert = styled(Alert)({
    width: "100%",
    display: "flex",
    alignItems: "center",
    fontSize: "18px",
});

export const CustomAutocomplete = styled(Autocomplete)(({ theme }) => ({
    "& .MuiInputLabel-root": {
        color: `${GlobalTheme.palette.black.primary.darker}`,
        fontWeight: "400",
        fontSize: "18px",
        lineHeight: "28px",
        fontFamily: "Calibre",

        "&.Mui-focused, &:hover, &:active": {
            color: `${GlobalTheme.palette.purple.primary.darker}`,
            backgroundColor: `${GlobalTheme.palette.white.primary.darker}`,
            padding: "0 7px 0 5px",
        },
        "&.MuiFormLabel-filled": {
            color: `${GlobalTheme.palette.purple.primary.darker}`,
            backgroundColor: `${GlobalTheme.palette.white.primary.darker}`,
            padding: "0 7px 0 5px",
        },
    },

    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            border: `1.5px solid ${GlobalTheme.palette.purple.primary.darker}`,
            borderRadius: "6px",
        },
        "&:hover fieldset": {
            borderColor: `${GlobalTheme.palette.purple.primary.darker}`,
        },
        "&.Mui-focused fieldset": {
            borderColor: `${GlobalTheme.palette.purple.primary.darker}`,
        },
    },

    "& .MuiAutocomplete-option": {
        '&[data-focus="true"]': {
            backgroundColor: `${GlobalTheme.palette.purple.primary.darker}`,
        },
    },
}));

export const CustomInputAdornment = styled(InputAdornment)(({ theme }) => ({
    "& .MuiTypography-root": {
        color: `${GlobalTheme.palette.purple.primary.main}`,
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: "28px",
        fontFamily: `${GlobalTheme.typography.fontFamily}`,
        paddingTop: "6px !important",
    },
}));

export const DynamicFormControl = styled(FormControl)(({ error }) => ({
    width: "100%",
    fontSize: "18px",
    "& .MuiInputLabel-root": {
        color: `${GlobalTheme.palette.black.primary.main}`,
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: "28px",
        fontFamily: `${GlobalTheme.typography.fontFamily}`,
        padding: "0 7px 0 5px",

        "&.Mui-focused, &:hover, &:active": {
            color: error
                ? `${GlobalTheme.palette.pink.primary.main}`
                : `${GlobalTheme.palette.black.primary.main} `,
            backgroundColor: `${GlobalTheme.palette.white.primary.main}`,
            padding: "0 7px 0 5px",
        },
        "&.MuiFormLabel-filled": {
            color: `${GlobalTheme.palette.black.primary.main}`,
            fontSize: "20px",
            backgroundColor: `${GlobalTheme.palette.white.primary.main}`,
            padding: "0 7px 0 5px",
        },
    },

    "& .MuiOutlinedInput-root": {
        paddingLeft: "10px",
        paddingRight: "40px",
        position: "relative",
        "& fieldset": {
            border: `1px solid ${GlobalTheme.palette.grey.primary.secondary}`,
            borderRadius: "8px",
        },
        "&:hover fieldset": {
            borderColor: error
                ? `${GlobalTheme.palette.pink.primary.main}`
                : `${GlobalTheme.palette.grey.primary.darker} `,
            border: `1px solid ${GlobalTheme.palette.grey.primary.secondary}`,
        },
        "&.Mui-focused fieldset": {
            borderColor: error
                ? `${GlobalTheme.palette.pink.primary.main}`
                : `${GlobalTheme.palette.grey.primary.darker} `,
            border: `1px solid ${GlobalTheme.palette.grey.primary.secondary}`,
        },
    },
    "&.MuiSelect-open .MuiSelect-icon": {
        visibility: "visible",
    },

    "&.Mui-focused .MuiSvgIcon-root ": {
        fill: `${GlobalTheme.palette.grey.primary.darker} !important`,
    },

    "& .MuiSvgIcon-root": {
        position: "absolute",

        top: "50%",
        transform: "translateY(-50%)",
    },
    "& input:-webkit-autofill": {
        WebkitBoxShadow: `0 0 0 1000px ${GlobalTheme.palette.white.primary.main} inset !important`,
        WebkitTextFillColor: `${GlobalTheme.palette.black.primary.main} !important`,
    },

    "& .Mui-error .MuiOutlinedInput-notchedOutline": {
        borderColor: `${GlobalTheme.palette.pink.primary.main}`,
    },
    "& .MuiFormHelperText-root": {
        color: error
            ? `${GlobalTheme.palette.pink.primary.main}`
            : `${GlobalTheme.palette.black.primary.main}`,
        fontSize: "16px",
    },
}));

export const CustomTradingContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    position: "relative",
    margin: "auto",
    width: "100%",
    height: "100%",

    boxSizing: "border-box",
    paddingTop: "80px",
    overflow: "hidden",
    marginBottom: 0,
    paddingBottom: 0,
    "@media (max-width: 740px)": {
        paddingTop: "60px",
        width: "100%",
    },
    "@media (max-width: 640px)": {
        width: "90%",
        paddingTop: 0,
        height: "100%",
    },
    "@media (max-width: 320px)": {
        paddingTop: 0,
        width: "100%",
        height: "100%",
        marginBottom: 0,
    },
}));

export const CustomContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    textAlign: "center",
    position: "relative",
    maxWidth: "1000px",
    margin: "auto",
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    paddingTop: "10px",
    marginBottom: 0,
    paddingBottom: 0,
    "@media (max-width: 640px)": {
        paddingTop: 0,
    },

    "@media (max-width: 320px)": {
        paddingTop: 0,
        marginBottom: 0,
    },
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
    "& .MuiList-root": {
        padding: "0",
        maxHeight: "200px",
        overflowY: "auto",
    },
    "& .MuiMenu-list": {
        padding: "10px",
    },
    "& .MuiMenuItem-root": {
        padding: "8px 16px",
        fontSize: "16px",
    },
}));

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 15,
    borderRadius: 10,
    backgroundColor: `${GlobalTheme.palette.purple.primary.other} `,
    [`& .${LinearProgress.bar}`]: {
        borderRadius: 10,
        backgroundColor: `${GlobalTheme.palette.purple.primary.main} `,
    },
    "& .MuiLinearProgress-bar": {
        backgroundColor: `${GlobalTheme.palette.purple.primary.main} `,
    },
}));

export const ContinueLaterBox = styled(Box)({
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "space-between",
    borderRadius: "8px",
    backgroundColor: `${GlobalTheme.palette.white.primary.main}`,
    border: `1px solid ${GlobalTheme.palette.lightGrey.primary.darker}`,
    padding: "40px",
    position: "relative",
    width: "100%",
    paddingLeft: "40px",
    paddingRight: "30px",
    "@media (max-width: 600px)": {
        padding: "20px",
        paddingLeft: "20px",
        paddingRight: "20px",
    },
    "@media (max-width: 320px)": {
        padding: "15px",
    },
});

export const ThankyouWrapper = styled(Container)({ height: "100vh" });
export const ContinueLateWrapper = styled(Container)({ height: "100vh" });
export const ContinueLaterTextFieldWrapper = styled("div")({
    position: "relative",
    width: "100%",
    "& input": {
        paddingRight: "50px",
    },
    "@media (max-width: 320px)": {
        width: "100%",
        "& input": {
            paddingRight: "1px",
            paddingLeft: 0,
        },
    },
    "@media (max-width: 600px)": {
        width: "100%",
        "& input": {
            paddingRight: "40px",
        },
    },
});

export const AcknowledgementBox = styled(Box)({
    backgroundColor: `${GlobalTheme.palette.purple.primary.lighter}`,
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    marginBottom: "20px",
    borderRadius: "8px",
    position: "relative",
    display: "flex",
    width: "90%",
    alignItems: "center",
    padding: "20px",
    flexDirection: "column",
    "@media (max-width: 640px)": {
        width: "90%",
        padding: "15px",
    },

    "@media (max-width: 320px)": {
        width: "100%",
        padding: "20px",
    },
});

export const CustomGrid = styled(Grid, {
    shouldForwardProp: (prop) => prop !== "item",
})(({ theme }) => ({
    paddingRight: "20px",
    paddingLeft: "20px",
    paddingBottom: "0px",

    [theme.breakpoints.down("sm")]: {
        marginTop: "0",
    },
}));

export const CustomGridButton = styled(Grid)(({ theme }) => ({
    paddingRight: "20px",
    paddingLeft: "20px",
    paddingBottom: "0px",

    [theme.breakpoints.down("sm")]: {
        with: "90%",
        marginTop: "0",
        paddingRight: "0px",
        paddingLeft: "0px",
    },
}));

export const StyledTimelineContent = styled(TimelineContent)`
    color: ${GlobalTheme.palette.white.primary.main};
    font-weight: ${GlobalTheme.typography.fontWeightMedium};
    padding-top: 5px;
    font-size: 20px;
`;
export const StyledTimelineDot = styled(TimelineDot)`
    background-color: ${GlobalTheme.palette.purple.primary.main};
    width: 30px;
    height: 30px;
    border-radius: 50%;
`;

export const PaymentTitleWrapper = styled(Container)({
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    width: "100%",
});
export const ButtonContainer = styled("div")((props) => ({
    display: "flex",
    justifyContent: props.hasDelete ? "flex-end" : "flex-start",
    width: "100%",
    gap: "10px",
    "@media (min-width: 641px)": {
        justifyContent: props.hasDelete ? "flex-end" : "flex-end",
        gap: "20px",
    },
    "@media (max-width: 480px)": {
        justifyContent: props.hasDelete ? "space-between" : "flex-end",
        gap: "10px",
    },
}));
